export enum SaleStatusEnum {
    OPEN = 'OPEN',
    PROCESS = 'PROCESS',
    RM_STOCK = 'RM_STOCK',
    FG_STOCK = 'FG_STOCK',
    CLOSE = 'CLOSE',
}